import { ApolloError } from '@apollo/client';
import { GraphQLFormattedError } from 'graphql';

import { ErrorExtensionsCode } from './consts';

enum ErrorClassificationType {
  ERRORS = 'errors',
  PARTIAL_ERRORS = 'partialErrors',
}

function getErrorClassification(error: GraphQLFormattedError) {
  if (error.extensions?.code === ErrorExtensionsCode.AUTH_NOT_AUTHORIZED) {
    return ErrorClassificationType.PARTIAL_ERRORS;
  }

  return ErrorClassificationType.ERRORS;
}

type ParsedPartialErrorsType = {
  [ErrorClassificationType.PARTIAL_ERRORS]?: readonly GraphQLFormattedError[];
  [ErrorClassificationType.ERRORS]?: readonly GraphQLFormattedError[];
};

export function parsePartialErrors(error?: ApolloError) {
  if (!error?.graphQLErrors) {
    return {};
  }

  return error.graphQLErrors.reduce<ParsedPartialErrorsType>((acc, error) => {
    const classification = getErrorClassification(error);
    return { ...acc, [classification]: [...(acc[classification] ?? []), error] };
  }, {});
}
